import {
  ADD_CART_TO_WISHLIST,
  ADD_CART_TO_WISHLIST_FULFILLED,
  ADD_CART_TO_WISHLIST_REJECTED,
  ADD_ITEMS_TO_CART,
  ADD_ITEMS_TO_CART_FULFILLED,
  ADD_ITEMS_TO_CART_REJECTED,
  CLEAR_ADD_CART_TO_WISHLIST,
  CLEAR_ADD_ITEMS_TO_CART,
  CLEAR_CART,
  FETCH_CART,
  FETCH_CART_FULFILLED,
  FETCH_CART_REJECTED,
  REMOVE_CART,
  REMOVE_CART_FULFILLED,
  REMOVE_VOUCHER,
  REPLACE_CART,
  UPDATE_ITEM_QUANTITY,
  UPDATE_ITEM_QUANTITY_FULFILLED,
  UPDATE_ITEM_QUANTITY_REJECTED,
  UPDATE_ITEM_REFERENCE,
  UPDATE_VOUCHER,
} from 'b2b-apps/shop/cart/redux/cart/actionTypes';
import {
  AddCartToWishlistAction,
  AddCartToWishlistFulfilledAction,
  AddCartToWishlistRejectedAction,
  AddItemsToCartAction,
  AddItemsToCartActionFulfilled,
  AddItemsToCartActionRejected,
  ClearAddCartToWishlistAction,
  ClearAddItemsToCartAction,
  ClearCartAction,
  FetchCartAction,
  FetchCartFulfilledAction,
  FetchCartRejectedAction,
  RemoveCartAction,
  RemoveCartFulfilledAction,
  RemoveVoucherAction,
  ReplaceCartAction,
  UpdateItemQuantityAction,
  UpdateItemQuantityFulfilledAction,
  UpdateItemQuantityRejectedAction,
  UpdateItemReferenceAction,
  UpdateVoucherAction,
} from 'b2b-apps/shop/cart/redux/cart/types';
import {
  AddItemsToCartType,
  CartItemType,
  CartType,
  WishlistWithAddedCartType,
} from 'b2b-common/core/cart/api/CartTypes';

const addCartToWishlist = (name: string): AddCartToWishlistAction => ({
  type: ADD_CART_TO_WISHLIST,
  payload: {
    name,
  },
});

const addCartToWishlistFulfilled = (
  name: string,
  response: WishlistWithAddedCartType,
): AddCartToWishlistFulfilledAction => ({
  type: ADD_CART_TO_WISHLIST_FULFILLED,
  payload: {
    name,
    data: response,
  },
});

const addCartToWishlistRejected = (name: string, error: ErrorType): AddCartToWishlistRejectedAction => ({
  type: ADD_CART_TO_WISHLIST_REJECTED,
  payload: {
    name,
    error,
  },
});

export const clearAddCartToWishlist = (): ClearAddCartToWishlistAction => ({
  type: CLEAR_ADD_CART_TO_WISHLIST,
});

const clearCart = (): ClearCartAction => ({
  type: CLEAR_CART,
});

const fetchCart = (): FetchCartAction => ({
  type: FETCH_CART,
});

const fetchCartFulfilled = (data: CartType): FetchCartFulfilledAction => ({
  type: FETCH_CART_FULFILLED,
  payload: {
    data,
  },
});

const fetchCartRejected = (error: ErrorType): FetchCartRejectedAction => ({
  type: FETCH_CART_REJECTED,
  payload: {
    error,
  },
});

const removeCart = (): RemoveCartAction => ({
  type: REMOVE_CART,
});

const removeCartFulfilled = (): RemoveCartFulfilledAction => ({
  type: REMOVE_CART_FULFILLED,
});

const removeVoucher = (): RemoveVoucherAction => ({
  type: REMOVE_VOUCHER,
});

const replaceCart = (data: CartType): ReplaceCartAction => ({
  type: REPLACE_CART,
  payload: {
    data,
  },
});

const updateItemQuantity = (
  sku: string,
  quantity: number,
): UpdateItemQuantityAction => ({
  type: UPDATE_ITEM_QUANTITY,
  payload: {
    sku,
    quantity,
  },
});

const updateItemQuantityFulfilled = (
  sku: string,
  quantity: number,
): UpdateItemQuantityFulfilledAction => ({
  type: UPDATE_ITEM_QUANTITY_FULFILLED,
  payload: {
    sku,
    quantity,
  },
});

const updateItemQuantityRejected = (
  sku: string,
  quantity: number,
): UpdateItemQuantityRejectedAction => ({
  type: UPDATE_ITEM_QUANTITY_REJECTED,
  payload: {
    sku,
    quantity,
  },
});

const updateItemReference = (sku: string, reference: string | null): UpdateItemReferenceAction => ({
  type: UPDATE_ITEM_REFERENCE,
  payload: {
    sku,
    reference,
  },
});

const updateVoucher = (code: string | null): UpdateVoucherAction => ({
  type: UPDATE_VOUCHER,
  payload: {
    code,
  },
});

const addItemsToCart = (items: CartItemType[]): AddItemsToCartAction => ({
  type: ADD_ITEMS_TO_CART,
  payload: {
    items,
  },
});

const addItemsToCartFulfilled = (data: AddItemsToCartType): AddItemsToCartActionFulfilled => ({
  type: ADD_ITEMS_TO_CART_FULFILLED,
  payload: {
    data,
  },
});

const addItemsToCartRejected = (error: ErrorType): AddItemsToCartActionRejected => ({
  type: ADD_ITEMS_TO_CART_REJECTED,
  payload: {
    error,
  },
});

const clearAddItemsToCart = (): ClearAddItemsToCartAction => ({
  type: CLEAR_ADD_ITEMS_TO_CART,
});

export {
  addCartToWishlist,
  addCartToWishlistFulfilled,
  addCartToWishlistRejected,
  addItemsToCart,
  addItemsToCartFulfilled,
  addItemsToCartRejected,
  clearAddItemsToCart,
  clearCart,
  fetchCart,
  fetchCartFulfilled,
  fetchCartRejected,
  removeCart,
  removeCartFulfilled,
  removeVoucher,
  replaceCart,
  updateItemQuantity,
  updateItemQuantityFulfilled,
  updateItemQuantityRejected,
  updateItemReference,
  updateVoucher,
};
